var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.closeTransition ? '' : 'md-fade-center'}},[_c('span',{staticClass:"el-tag",class:[_vm.type ? 'el-tag-' + _vm.type : '', {'is-hit': _vm.hit}]},[_vm._t("default"),_vm._v(" "),(_vm.closable)?_c('i',{staticClass:"el-tag-close el-icon-close",on:{"click":_vm.handleClose}}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6e6d852","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tag/src/tag.vue
// module id = null
// module chunks = 